export default __webpack_public_path__ + "static/media/BackgroundPwa.7eb11261.png";